/*
 Copyright (c) 2017 Wells Fargo. 455 Market St., San Francisco, CA 94105 All rights reserved.

 This software is the confidential and proprietary information of Wells Fargo
 bank. ('Confidential Information'). You shall not disclose such Confidential
 Information and shall use it only in accordance with the terms of the license
 agreement you entered into with WellsFargo.

 Author: Kushala Sathyamurthy

 Description: This component provides a hidden control to close the Navigation Menu for
 mobile screen-reader users. This meets the accessibility recommendation to
 provide a way for screen-reader users to close the menu.
 */
import React from 'react';
import { connect } from 'react-redux';
import AccessibleClick from 'wfui-digital-core/es/AccessibleClick';
import { closeNavigationMenu as _closeNavigationMenu } from '../../../../lib/store/navigation-menu/actions';
import styles from './NavigationMenuWindow.less';

var NavigationMenuAccessibilityClose = function NavigationMenuAccessibilityClose(_ref) {
  var closeNavigationMenu = _ref.closeNavigationMenu;
  return /*#__PURE__*/React.createElement(AccessibleClick, null, /*#__PURE__*/React.createElement("a", {
    role: "button",
    className: styles.hiddenControl,
    onAccessibleClick: function onAccessibleClick() {
      closeNavigationMenu();
    }
  }, "Close Navigation Menu"));
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    closeNavigationMenu: function closeNavigationMenu() {
      return dispatch(_closeNavigationMenu());
    }
  };
};

export default connect(null, mapDispatchToProps)(NavigationMenuAccessibilityClose);